import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BillingLayer from "../components/BillingLayer";

const BillingPage = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Settings - Billing" />
                <BillingLayer />
            </MasterLayout>
        </>
    );
};

export default BillingPage; 